<template>
	<div class="dashboard contain pad-x pt-32 lg-pt-44 pb-72 lg-pb-96 bg-gradient">
		<h1 class="mb-24 lg-mb-28 fs-26 lg-fs-32 fw-800">Welcome back, {{ $activeUser.firstName }}!</h1>
		<div class="dashboard-layout">
			<main class="grid gap-16 lg-gap-24">
				<CardAvi class="hide-lg"/>
				<CardJobsOfferedMe />
				<CardJobsInQueue />
				<CardJobsInactiveQueue />
				<CardRecentMessages />
				<CardToDoList />
				<CardUpcomingJobs />
				<CardPendingReviews />
				
			</main>
			<aside class="grid gap-16 lg-gap-24">
				<CardAvi class="show-lg"/>
				<CardAvailability />
				<CardAnnouncements v-if="false"/>
				<CardPartnerResources />
			</aside>
		</div>
	</div>
</template>

<script>
import CardJobsOfferedMe from '@/components/dashboard/CardJobsOfferedMe';
import CardPendingReviews from '@/components/dashboard/CardPendingReviews';
import CardPartnerResources from '@/components/dashboard/CardPartnerResources';
import CardUpcomingJobs from '@/components/dashboard/CardUpcomingJobs';
import CardAnnouncements from '@/components/dashboard/CardAnnouncements';
import CardRecentMessages from '@/components/dashboard/CardRecentMessages';
import CardToDoList from '@/components/dashboard/CardToDoList';
import CardAvi from '@/components/dashboard/CardAvi';
import CardJobsInQueue from '@/components/dashboard/CardJobsInQueue';
import CardJobsInactiveQueue from '@/components/dashboard/CardJobsInactiveQueue';
import CardAvailability from '@/components/profile/CardAvailability';

export default {
  name: 'Dashboard',
  components: {
	CardJobsOfferedMe,
    CardPendingReviews,
    CardPartnerResources,
    CardUpcomingJobs,
	CardAnnouncements,
	CardRecentMessages,
	CardToDoList,
	CardAvi,
	CardJobsInQueue,
	CardJobsInactiveQueue,
	CardAvailability,
  },
  computed: {
	subscriptionLevel() {
      return this.$store.getters['subscriptions/currentLevel'];
    },
	isStudio() {
      const level = this.subscriptionLevel;
      return !!level && !level.canBeHired;
    },
    showWelcomeModal: {
      /**
       * @returns {boolean}
       */
      get() {
        return !!this.$store.getters['onboarding/showWelcomeModal'];
      },
      /**
       * @param {boolean} value
       * @returns {void}
       */
      set(value) {
        this.$store.commit('onboarding/setShowWelcomeModal', value);
      },
    },
  },
  metaInfo: {
    title: 'Dashboard',
  },
};
</script>
